import React from 'react';
import { GrammarlyEditorPlugin } from '@grammarly/editor-sdk-react';
import environment from '../environment';

const GrammarlyEditorWrapper = ({ children }) => {
  return environment.grammarly.clientId ? <GrammarlyEditorPlugin>{children}</GrammarlyEditorPlugin> : <>{children}</>;
};

export default GrammarlyEditorWrapper;
